export const ROUTES = {
  NOT_FOUND: '/not-found',
  BOOKING: '/users/:userId/booking',
  BOOKING_PRODUCTS: '/users/:userId/booking/products',
  BOOKING_PRODUCTS_DEPRECATED: '/:domain/products',
  BOOKING_TIME_SLOTS_DEPRECATED: '/users/:userId/booking/time-slots',
  BOOKING_TIME_SLOT_DETAILS: '/users/:userId/booking/time-slots/:timeSlotConfigId',
  BOOKING_JOB_DETAILS: '/users/:userId/booking/jobs/:jobConfigId',
  PAYMENT: '/users/:userId/payments',
  STRIPE_PAYMENT_COMPLETE: '/stripe-payment-complete',
  PAYMENT_DEPRECATED: '/:domain/payments',
  MEETING: '/users/:userId/meetings',
  DETAILED_MEETING: '/users/:userId/meetings/:meetingId',
  DETAILED_MEETING_DEPRECATED: '/:domain/meetings/:meetingId',
  MEETING_RESCHEDULE: '/users/:userId/meetings/:meetingId/reschedule',
  MEETING_CANCEL: '/users/:userId/meetings/:meetingId/cancel',
  MEETING_EXPIRED: '/users/:userId/meetings/:meetingId/expired',
  MEETING_BATCH: '/users/:userId/meeting-batches',
  DETAILED_MEETING_BATCH: '/users/:userId/meeting-batches/:meetingBatchId',
  DETAILED_MEETING_BATCH_DEPRECATED: '/:domain/meeting-batches/:meetingBatchId',
  MEETING_BATCH_RESCHEDULE: '/users/:userId/meeting-batches/:meetingBatchId/meeting/:meetingId/reschedule',
  MEETING_BATCH_CANCEL: '/users/:userId/meeting-batches/:meetingBatchId/meeting/:meetingId/cancel',
  MEETING_BATCH_EXPIRED: '/users/:userId/meeting-batches/:meetingBatchId/expired',
  REQUISITES: '/users/:userId/requisites/:customPaymentProviderId',
};
